module.exports = __webpack_public_path__ + "static/media/approver-check-icon.552f4683.svg";